import React, { useState } from "react";
import axios from "axios";
import { Offcanvas } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {toast} from "react-toastify";

const EventForm = () => {

    const [eventName, setEventName] = useState("");
    const [date, setDate] = useState(new Date());
    const [url, setUrl] = useState("");
    const [frameImage, setFrameImage] = useState(null);
    const [allowDownload, setAllowDownload] = useState(false);
    const [overlayImage, setOverlayImage] = useState(null);


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState([]);


    const handleFileChange = (e) => {
        if (e.target.name === "frameImage") {
            setFrameImage(e.target.files[0]);
        } else {
            setOverlayImage(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let rahmenbild = "";
        let overlaybild = "";

        // Bild-Upload zu S3
        const formDataFrame = new FormData();
        formDataFrame.append("file", frameImage);

        const formDataOverlay = new FormData();
        formDataOverlay.append("file", overlayImage);

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/s3/upload`, formDataFrame, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response.data || 'Hochladen erfolgreich!');
            rahmenbild = response.data.filename;
        } catch (error) {
            console.error('Fehler beim Hochladen:', error);
            console.log('Fehler beim Hochladen.');
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/s3/upload`, formDataOverlay, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response.data || 'Hochladen erfolgreich!');
            overlaybild = response.data.filename;
        } catch (error) {
            console.error('Fehler beim Hochladen:', error);
            console.log('Fehler beim Hochladen.');
        }

        try {
            console.log(date);
            const datum = new Date(date);

            // Event erstellen
            const eventData = {
                eventName,
                allowDownload,
                url,
                rahmenbild,
                overlaybild
            };

            await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/events`, eventData);
            toast.success("Event erstellt!");
        } catch (error) {
            console.error("Fehler beim Erstellen des Events:", error);
        }
    };

    return (
        <>
            <button className="btn btn-primary" onClick={handleShow}>
                Neues Event
            </button>

            <Offcanvas show={show} onHide={handleClose} placement="end" style={{width: '40rem'}}>
                <div id="resize-handle"></div>
                <div className="offcanvas-header"
                     style={{borderLeft: '10px #3499be solid', backgroundColor: '#3499be20', borderBottom: '0px'}}>
                    <h5 className="offcanvas-title" id="formOffcanvasLabel">
                        Neues Event
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="Close"
                    ></button>
                </div>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Event Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={eventName}
                                onChange={(e) => setEventName(e.target.value)}
                                placeholder=""
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Event URL</label>
                            <input type="text"
                                   className="form-control"
                                   name="example-text-input"
                                   value={url}
                                   onChange={(e) => setUrl(e.target.value)}
                                   placeholder="150jahreav"/>
                        </div>


                        <div className="mb-3">
                            <label className="form-label">Download</label>
                            <div className="form-selectgroup form-selectgroup-boxes d-flex flex-column">
                                <label className="form-selectgroup-item flex-fill">
                                    <input
                                        type="checkbox"
                                        name="form-project-manager[]"
                                        value="1"
                                        className="form-selectgroup-input"
                                        checked={allowDownload}
                                        onChange={(e) => setAllowDownload(!allowDownload)}
                                    />

                                    <div className="form-selectgroup-label d-flex align-items-center p-3">
                                        <div className="me-3">
                                            <span className="form-selectgroup-check"></span>
                                        </div>
                                        <div
                                            className="form-selectgroup-label-content d-flex align-items-center">
                                            <div>
                                                <div className="font-weight-medium">Downloads erlauben</div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>


                        <div className="mb-3">
                            <div className="form-label">Rahmen</div>
                            <input type="file" className="form-control" name="frameImage" onChange={handleFileChange}/>
                        </div>

                        <div className="mb-3">
                            <div className="form-label">Overlay</div>
                            <input type="file" className="form-control" name="overlayImage"
                                   onChange={handleFileChange}/>
                        </div>

                        <div className="mb-3">
                            <button type="submit" className="btn btn-primary ms-auto">Erstellen</button>
                        </div>


                    </form>
                </div>
            </Offcanvas>
        </>
    )

};

export default EventForm;
